import { wardrobeData } from '@/Interfaces/common';

export const getAllItemIDs = (wardrobe: wardrobeData) => {
    return [
        ...wardrobe.shelves.map((shelf)=>{
            return [
                shelf.templates.basket?.id,
                shelf.templates.shelfBracketLeft?.disabled?'':shelf.templates.shelfBracketLeft?.id,
                shelf.templates.shelfBracketRight?.disabled?'':shelf.templates.shelfBracketRight?.id,
                shelf.templates.rodHolderLeft?.disabled?'':shelf.templates.rodHolderLeft?.id,
                shelf.templates.rodHolderRight?.disabled?'':shelf.templates.rodHolderRight?.id,
                shelf.templates.rod?.disabled?'':shelf.templates.rod?.id,
                shelf.templates.trouserRack?.id,
                shelf.templates.pullOutFrame?.id,
                shelf.templates.panel?.id,
                shelf.templates.shelf?.id,
                shelf.templates.rodCap?.id,
                shelf.templates.rodCapLeft?.id,
                shelf.templates.rodCapRight?.id,
                shelf.templates.bracketLeftExtra?.id,
                shelf.templates.bracketRightExtra?.id,
                shelf.templates.bracketCenterExtra?.id,
                ...(shelf.templates.separators || []).map(s => s.id),
                ...shelf.templates.assets
                    .filter((item)=>!item.disabled)
                    .map((item)=>item.id),
            ];})
            .flat(),
        ...wardrobe.modules.map((module)=>[
            ...module.templates
                .filter((rack)=>!rack.disabled)
                .map((rack)=>rack.id),
            ...(module.assets || [])
                .filter((item)=>!item.disabled)
                .map((asset)=>asset.id),
        ])
            .flat(),
        ...wardrobe.rails.map((railGroup)=>{
            return [
                ...railGroup.templates
                    .filter((rail)=>!rail.disabled)
                    .map((rail)=>rail.id),
                ...(railGroup.assets || [])
                    .filter((item)=>!item.disabled)
                    .map((asset)=>asset.id),
            ];})
            .flat(),
    ]
        .filter((item)=>item);
};
